module Easypass {
    angular.module('easypass').filter('range', [() => {
        return (input: Array<number>, min: string, max: string): Array<number> => {
            for (var i = parseInt(min); i <= parseInt(max); i++)
                input.push(i);
            return input;
        };
    }]);
}